<p-panel [toggleable]="true" class="mt-5">
  <ng-template #header
    ><div>
      <i class="fa-solid fa-chart-line mr-3"></i>Energy Meter chart of last hour
    </div></ng-template
  >
  <p-chart
    #chart
    type="line"
    [data]="data"
    [options]="options"
    class="h-[20rem] mb-15"
  />

  <div class="float-right -mt-10">
    <p-button
      [class]="zoomEnabled ? 'inline-flex' : 'hidden'"
      type="button"
      label="Reset Zoom"
      icon="pi pi-refresh"
      (click)="resetZoom()"
    />
    <p-button
      class="ml-5"
      type="button"
      [label]="zoomEnabled ? 'Disable Zoom' : 'Enable Zoom'"
      [icon]="zoomEnabled ? 'pi pi-search-minus' : 'pi pi-search-plus'"
      (click)="toggleZoom()"
    />
  </div>
</p-panel>
